import * as Sentry from "@sentry/react";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../lib/firebase.js";
import type { ListItem } from "../types/index.js";

export function useListItems(listId: string | null) {
  const [items, setItems] = useState<ListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!listId) {
      setItems([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const q = query(
      collection(db, "lists", listId, "items"),
      where("deletedAt", "==", null),
      orderBy("order", "asc"),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const newItems: ListItem[] = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            itemId: doc.id,
            text: data.text,
            order: data.order,
            createdByName: data.createdByName,
            deletedAt: null,
            undoExpiresAt: null,
            createdAt: data.createdAt?.toDate?.().toISOString() ?? "",
            updatedAt: data.updatedAt?.toDate?.().toISOString() ?? "",
          };
        });
        setItems(newItems);
        setLoading(false);
      },
      (err) => {
        Sentry.captureException(err);
        setError(err);
        setLoading(false);
      },
    );

    return unsubscribe;
  }, [listId]);

  return { items, loading, error };
}
